import { useEffect, useState } from "react";

const AnimatedCounter = ({ value, duration = 1200, color = "" }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const end = Number(value) || 0;

    if (start === end) return;

    const incrementTime = 16; // ~60fps
    const totalSteps = duration / incrementTime;
    const step = end / totalSteps;

    const timer = setInterval(() => {
      start += step;

      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, incrementTime);

    return () => clearInterval(timer);
  }, [value, duration]);

  return (
    <span
      style={{
        fontVariantNumeric: "tabular-nums",
        letterSpacing: "2px",
        color: color,
      }}>
      {count.toLocaleString()}
    </span>
  );
};

export default AnimatedCounter;
